import { render, staticRenderFns } from "./DataListjobRiskAssessments.vue?vue&type=template&id=913f8b1e&scoped=true&"
import script from "./DataListjobRiskAssessments.vue?vue&type=script&lang=js&"
export * from "./DataListjobRiskAssessments.vue?vue&type=script&lang=js&"
import style0 from "./DataListjobRiskAssessments.vue?vue&type=style&index=0&id=913f8b1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913f8b1e",
  null
  
)

export default component.exports